export default __webpack_public_path__ + "fonts/12759b642687edb910d05c98578a14ad.eot";